import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import Help from '../../../generics/help';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../../config');
var report = require('../../../generics/report_head');

class SamplesTraceability extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);
		this.getHourFormat = this.getHourFormat.bind(this);
		this.getComponents = this.getComponents.bind(this);
		
		this.setTable = this.setTable.bind(this);
		this.dateCompare = this.dateCompare.bind(this);


		this.state = {
			health_facilities_id:"",

			component_type:"all",
			components:[],
			start_date:"",
			end_date:"",
			services:[],
			service:"all",
			
			listado:[],
			columns:[
				{title:'No.', width:'40px'},
				{title:'Petición', width:'350px'},
				{title:'Fecha/Hr. Petición', width:'120px'},				
				{title:'Muestra', width:'120px'},
				{title:'Fecha/Hr. Muestra', width:'120px'},
				{title:'Usuario que validó', width:'300'},
				{title:'Paciente', width:'350px'},
				{title:'Grupo &RH Lab.', width:'120px'},
				{title:'Unidad', width:'120px'},
				{title:'Componente', width:'300px'},
				{title:'Servicio', width:'350px'},
				{title:'Fecha/Hr. Validación Muestra', width:'140px'},
				{title:'Fecha/Hr. Alta Reserva', width:'140px'},
				{title:'Fecha/Hr. Retirar Reserva', width:'140px'},
				{title:'Fecha/Hr. Transfución', width:'140px'},
				{title:'Fecha/Hr. Devolución', width:'140px'},
			],
			filename:"Trazabilidad de Muestras",
			date_hour:"",
			medical:"",
			format:"",
			totals:[]
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split("/");
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				date_hour:aux[0]+' '+hours,
				start_date:date[2]+'-'+date[1]+'-'+date[0],
				end_date:date[2]+'-'+date[1]+'-'+date[0],
			});
		});
	}

	componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)
		this.getComponents();
		
		fetch(Config.default.apiGateway.URL+'lookups/order_by?type=health_services&option=name', {
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(msg){
					swal("Error", msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({services:response});
			}
		});

		this.setTable();
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	getComponents(){
		fetch(Config.default.apiGateway.URL+'lookups?type=blood_component_type&option=actives&order=false', {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					components: response
				});
			}
		});
	}

	
	setTable(){
		this.$el = $(this.el);
		
		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [
				{
                	extend: 'excelHtml5',
                	title: this.state.filename
            	},
            	{
                	extend: 'pdf',
                	title: this.state.filename,
                	orientation:'landscape',
                	customize: (doc)=> { 
                		doc.content.unshift({
							image: this.props.header_document,
							alignment:'center',
							width:this.props.w_head
						});
						doc.content.splice(2, 0, {text: 'Fecha de emisión '+this.state.date_hour, margin:[10,0,0,10] });

						this.state.totals.map((t, i)=>{
							doc.content.push({
								text:t.user+', Muestras: '+t.samples+', Reservas: '+t.reserves+
								', Envíos: '+t.deliveries+', Devoluciones: '+t.returns
							})
						})

						//doc.content[4].table.widths=["40%","10%","10%","10%","15%", "15%"];

						doc.styles.tableHeader.fontSize = 6;
                		doc.defaultStyle.fontSize = 6; 

                		doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};

                	} 
            	}
            ],
			data: this.state.listado,
			columns:this.state.columns,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"fnInfoCallback":null,
			},
			paging:false,
			responsive:true,
			searching: false,
			scrollY:"32em",
			scrollX: true,
			autoWidth: false,
			info:false

		});

		$('.dataTables_filter').css('float', 'left');
		$('.dt-buttons').css({'float':'right', 'width':'50%'});

		if (table.rows().indexes().length === 0 ) {
			table.buttons('.buttons-html5').disable();
		}else {
			table.buttons('.buttons-html5').enable();
		}
	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});
		

		if(document.getElementById(e.target.name).className.includes('error')){
			document.getElementById(e.target.name).classList.remove('error');
		}
	}

	searching(){
		if(this.isValidForm()){
			if(this.dateCompare()){
				this.props.waiting.handleShow('Buscando...');

				var columns = []

				if(this.state.format === 'simplificado'){
					columns = [
						{title:'Petición', width:'350px'},
						{title:'Paciente', width:'350px'},
						{title:'Grupo &RH Pac.', width:'120px'},
						{title:'Fecha/Hr. Petición', width:'120px'},				
						{title:'Muestra', width:'120px'},
						{title:'Fecha/Hr. Muestra', width:'120px'},
						{title:'Usuario', width:'300'},
						{title:'Fecha/Hr. Validación Muestra', width:'140px'},
						{title:'Usuario que validó', width:'300'},
						{title:'Grupo &RH Lab.', width:'120px'},
						{title:'Unidad', width:'120px'},
						{title:'Componente', width:'300px'},
						{title:'Fecha/Hr. Alta Reserva', width:'140px'},
						{title:'Fecha/Hr. Retirar Reserva', width:'140px'},
					]
				}else if(this.state.format === 'completo'){
					columns = [
						{title:'Petición', width:'350px'},
						{title:'Paciente', width:'350px'},
						{title:'Grupo &RH Pac.', width:'120px'},
						{title:'Fecha/Hr. Petición', width:'120px'},	
						{title:'Muestra', width:'120px'},
						{title:'Fecha/Hr. Muestra', width:'120px'},
						{title:'Usuario', width:'300'},	
						{title:'Fecha/Hr. Validación Muestra', width:'140px'},
						{title:'Usuario que validó', width:'300'},
						{title:'Grupo &RH Lab.', width:'120px'},
						{title:'Unidad', width:'120px'},
						{title:'Componente', width:'300px'},
						{title:'Servicio', width:'350px'},
						{title:'Fecha/Hr. Alta Reserva', width:'140px'},
						{title:'Usuario que reserva', width:'300'},
						{title:'Fecha/Hr. Envío', width:'140px'},
						{title:'Usuario que envío', width:'300'},
						{title:'Fecha/Hr. Devolución', width:'140px'},
						{title:'Usuario que devolvió', width:'300'},
					]

				}

				var obj = {
					health_facilities_id:this.state.health_facilities_id,
					component_type: this.state.component_type,
					health_service:this.state.service,
					start_date:this.state.start_date,
					end_date:this.state.end_date,
				}
				
				fetch(Config.default.apiGateway.URL+'reports/samples_traceability',{
					method: 'POST',
					body:JSON.stringify(obj),
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					
					if(res.ok){
						return res.json();
					}else{
						this.props.waiting.handleClose();
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
						this.setState({
							listado: [],
						});
						var list = [];

						response.resp.map((res, i)=>{
							if(this.state.format === 'simplificado'){
								list.push([
									res.petition_type,
									res.patient,
									res.patient_grh,
									res.petition_date !== null ?
										moment(res.petition_date).format('DD/MM/YYYY')+' '+
										moment(res.petition_hour, 'HH:mm:ss').format('HH:mm')
									: '',
								    res.sample,
								    res.sample_timestamp !== null ?
								    	moment(res.sample_timestamp).format('DD/MM/YYYY HH:mm')
								    : '',
								    res.sample_user,
								    (res.validation_date !== null ?
										moment(res.validation_date).format('DD/MM/YYYY')
									:'')+' '+
									(res.validation_hour !== null ?
										moment(res.validation_hour, 'H:mm:ss.sssssss').format('HH:mm')
									:''),
									res.user_validate,
									res.sample_grh,
									res.unit_number,
									res.component,
									res.reserved_timestamp !== null ?
										moment(res.reserved_timestamp).format('DD/MM/YYYY HH:mm')
									: '',
									res.remove_reserved_timestamp !== null ?
										moment(res.remove_reserved_timestamp).format('DD/MM/YYYY HH:mm')
									: ''
								])
							}else if(this.state.format === 'completo'){
								list.push([
									res.petition_type,
									res.patient,
									res.patient_grh,
									res.petition_date !== null ?
										moment(res.petition_date).format('DD/MM/YYYY')+' '+
										moment(res.petition_hour, 'HH:mm:ss').format('HH:mm')
									: '',
								    res.sample,
								    res.sample_timestamp !== null ?
								    	moment(res.sample_timestamp).format('DD/MM/YYYY HH:mm')
								    : '',
								    res.sample_user,
									(res.validation_date !== null ?
										moment(res.validation_date).format('DD/MM/YYYY')
									:'')+' '+
									(res.validation_hour !== null ?
										moment(res.validation_hour, 'H:mm:ss.sssssss').format('HH:mm')
									:''),
									res.user_validate,
									res.sample_grh,
									res.unit_number,
									res.component,
									res.service,
									res.reserved_timestamp !== null ?
										moment(res.reserved_timestamp).format('DD/MM/YYYY HH:mm')
									: '',
									res.reserve_user,
									res.delivered_date !== null ?
										moment(res.delivered_date).format('DD/MM/YYYY')+' '+
										moment(res.delivered_hour, 'HH:mm:ss').format('HH:mm')
									: '',
									res.delivered_user,
									res.return_timestamp !== null ?
										moment(res.return_timestamp).format('DD/MM/YYYY HH:mm')
									: '',
									res.return_user
								])
							}

						})

						this.setState({
							listado:list,
							columns:columns,
							totals:response.totals
						});

						setTimeout(()=>{
							this.props.waiting.handleShow('Cargando...');
							this.$el = $(this.el);
							this.$el.DataTable().destroy();
							this.$el.empty();
						}, 500);

						setTimeout(()=>{
							this.props.waiting.handleClose();
							this.setTable();
						}, 1000);
							
						this.props.waiting.handleClose();
					}
				});
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}
			
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;
		if(this.state.search_type === 'date'){
			if(ini !== 'Invalid date' && fin !== 'Invalid date'){
				if(fin < ini){
					date_ok = false;
					document.getElementById('end_date').classList.add('error');
				}else{
					document.getElementById('end_date').classList.remove('error');
				}
			}else{
				date_ok = false;
			}		
		}
		
		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}


	render(){
		const {t} = this.props;
		const { selectedOption } = this.state;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					Pacientes ->
					{t('sidebar.nav.reports.MAIN')} ->
					Trazabilidad de Muestras
					</h5>
				</div>
				<Help 
					{...this.props}
		            menu={"help_storage"} 
		            submenu={"help_samples_traceability"}  />
		            
				<div className="form-group" style={{paddingLeft:"0.5em"}}>

					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
								
								<div className="form-group">
									<span className="span-min">Fecha Desde</span>
									<input type="date" className="form-control hour-input" name="start_date" id="start_date"
										value={this.state.start_date} onChange={this.handleChange} required />
								</div>
								<div className="form-group">
									<span className="span-min">Fecha Hasta</span>
									<input type="date" className="form-control hour-input" name="end_date" id="end_date"
										value={this.state.end_date} onChange={this.handleChange} required />
								</div>

								<div className="form-group">
									<span className="span-min">Servicio</span>
									<select className="form-control" name="service" id="service"
										value={this.state.service || ""} onChange={this.handleChange}>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.services.map((f, i)=>{
											return <option key={i} value={f.key}>
												{f.name}
											</option>
										})}
									</select>
								</div>

								<div className="form-group">
									<span className="span-min">Componente</span>
									<select className="form-control" name="component_type" id="component_type"
										value={this.state.component_type} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.components.map((c, i)=>{
											return <option key={i} value={c.key}>
												{c.name}
											</option>
										})}
									</select>
								</div>
								<div className="form-group">
									<span className="span-min">Formato</span>
									<select className="form-control" name="format" id="format"
										value={this.state.format} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="simplificado">Simplificado</option>
										<option value="completo">Completo</option>
									</select>
								</div>

								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10 form-group">
								<div className="col-xs-12">
									<div className="col-xs-12 col-sm-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline"}}>
										<span>
											{this.state.filename}
										</span>
									</div>
									<div className="col-xs-12" >
										<span style={{marginLeft:"5px"}}>
											Fecha de emisión: 
											<b style={{marginLeft:"5px"}}>{this.state.date_hour}</b>
										</span>
									</div>
									
								</div>
								
								<div className="col-xs-12 form-group" id="table-to-pdf">									
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} className={"expenses-discards"} id="table-to-xls" 
											width="100%" ref={el => this.el = el}>
										</table>
									</div>
								</div>
								<div className="col-xs-12">
									{this.state.totals.map((t, i)=>(
										<div>
											<label>{t.user}</label>:  
											<label style={{marginLeft:8}}>Muestras</label> <span>{t.samples}</span> 
											<label style={{marginLeft:8}}>Reservas</label> <span>{t.reserves}</span> 
											<label style={{marginLeft:8}}>Envíos</label> <span>{t.deliberies}</span> 
											<label style={{marginLeft:8}}>Devoluciones</label> <span>{t.returns}</span> 
										</div>
									))}
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default translate('translations') (SamplesTraceability);